import { Component, inject, signal } from '@angular/core';
import { ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AuthService } from '../../core/services/auth.service';
import { ApprovalApiError } from '../../core/errors/approval-api-error';
import { AuthShell } from '../../shared/layout/auth-shell';

@Component({
  selector: 'app-verify-otp',
  imports: [
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    AuthShell,
  ],
  templateUrl: './verify-otp.html',
  styleUrl: './verify-otp.scss',
})
export class VerifyOtp {
  private readonly fb = inject(FormBuilder);
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  readonly loading = signal(false);
  readonly errorMessage = signal<string | null>(null);
  readonly email = signal(this.route.snapshot.queryParamMap.get('email') ?? '');

  readonly form = this.fb.nonNullable.group({
    otp: ['', [Validators.required, Validators.minLength(4)]],
  });

  submit(): void {
    if (this.form.invalid || this.loading() || !this.email()) {
      this.form.markAllAsTouched();
      return;
    }

    this.loading.set(true);
    this.errorMessage.set(null);
    const { otp } = this.form.getRawValue();

    this.authService.verifyOtp({ email: this.email(), otp }).subscribe({
      next: (result) => {
        this.loading.set(false);
        if (result.temporaryPassword) {
          this.router.navigate(['/change-password']);
        } else {
          this.router.navigate(['/queue']);
        }
      },
      error: (err: unknown) => {
        this.loading.set(false);
        this.errorMessage.set(
          err instanceof ApprovalApiError ? err.message : 'OTP verification failed.',
        );
      },
    });
  }
}
